import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import '../Resources/dashboard.css';
import axios from '../../axios.js';
import moment from 'moment/moment';
import Sidebar from './sidebar.js';
import Navbar from './navbar.js';

function Newcrm_createloanlogin(){



  
   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const editId=sessionStorage.getItem("EditId00");
 const counterid=sessionStorage.getItem("CounterId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/* if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{

   */}

    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable
const[customers,setcustomers] = useState([],);//SetData Variable
const[cdefault,setcdefault] = useState(0);

//Error Variable
const[errorvar,seterrorvar] = useState();

//customers_count
const[customers_count,setcustomers_count] = useState(1);
//csuccess
//const[ccsuccess,setccsuccess] = useState(0);
//date

//bank_name
const[bank_name,setbank_name]=useState();const updatebank_name = (event) => { setbank_name(event.target.value);}; const[bank_name_er,setbank_name_er]=useState();
//branch_address
const[branch_address,setbranch_address]=useState();const updatebranch_address = (event) => { setbranch_address(event.target.value);}; const[branch_address_er,setbranch_address_er]=useState();
//application_amount
const[application_amount,setapplication_amount]=useState();const updateapplication_amount = (event) => { setapplication_amount(event.target.value);}; const[application_amount_er,setapplication_amount_er]=useState();
//sanction_amount
const[sanction_amount,setsanction_amount]=useState();const updatesanction_amount = (event) => { setsanction_amount(event.target.value);}; const[sanction_amount_er,setsanction_amount_er]=useState();
//login_status
const[login_status,setlogin_status]=useState();const updatelogin_status = (event) => { setlogin_status(event.target.value);}; const[login_status_er,setlogin_status_er]=useState();
//date_applied
const[date_applied,setdate_applied]=useState();const updatedate_applied = (event) => { setdate_applied(event.target.value);}; const[date_applied_er,setdate_applied_er]=useState();
//date_result
const[date_result,setdate_result]=useState();const updatedate_result = (event) => { setdate_result(event.target.value);}; const[date_result_er,setdate_result_er]=useState();
//login_remarks
const[login_remarks,setlogin_remarks]=useState();const updatelogin_remarks = (event) => { setlogin_remarks(event.target.value);}; const[login_remarks_er,setlogin_remarks_er]=useState();
//login_number
const[login_number,setlogin_number]=useState();const updatelogin_number = (event) => { setlogin_number(event.target.value);}; const[login_number_er,setlogin_number_er]=useState();


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();



    

//******************* CREATE NEW LEAD FUNCTION START ********************//
function createnewlogin(){

 
  //Setting Error Variables
  setbank_name_er(" "); setbranch_address_er(" "); setapplication_amount_er(" "); setsanction_amount_er(" "); setlogin_status_er(" "); setdate_applied_er(" "); setdate_result_er(" "); setlogin_remarks_er(" "); 


//Checking if user loggedin
if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((editId!=null)||(editId!=" "))/*&&((counterid!=null)||(counterid!=" "))*/){
 
 
  axios.post("loancrm-create-newloanlogin", {
   Log_id:logid,
   Token:token,
   Lead_id : editId,
   Bank_name : bank_name,
   Branch_address : branch_address,
   Application_amount : application_amount,
   Sanction_amount : sanction_amount,
   Login_status : login_status,
   Date_applied : moment(date_applied).format('YYYY-MM-DD'),
   Date_result : moment(date_result).format('YYYY-MM-DD'),
   Login_remarks : login_remarks,
   Login_number : login_number,

 })
 .then((response) => {
  
  //Invalid Entries
 
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  return; }

  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
  
  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("EditId00");
     window.location.replace("/");

  }

   //Validation Errors
 if(response.data.validatorerror){

  //setlead_id_er(response.data.validatorerror.Lead_id);
  setbank_name_er(response.data.validatorerror.Bank_name);
  setbranch_address_er(response.data.validatorerror.Branch_address);
  setapplication_amount_er(response.data.validatorerror.Application_amount);
  setsanction_amount_er(response.data.validatorerror.Sanction_amount);
  setlogin_status_er(response.data.validatorerror.Login_status);
  setdate_applied_er(response.data.validatorerror.Date_applied);
  setdate_result_er(response.data.validatorerror.Date_result);
  setlogin_remarks_er(response.data.validatorerror.Login_remarks);
  setlogin_number_er(response.data.validatorerror.Login_number);

  return;

}
//Invalid Entries
if(response.data.error==102){ 
  
  //setlead_id_er(response.data.lead_id_er);
  setbank_name_er(response.data.bank_name_er);
  setbranch_address_er(response.data.branch_address_er);
  setapplication_amount_er(response.data.application_amount_er);
  setsanction_amount_er(response.data.sanction_amount_er);
  setlogin_status_er(response.data.login_status_er);
  setdate_applied_er(response.data.date_applied_er);
  setdate_result_er(response.data.date_result_er);
  setlogin_remarks_er(response.data.login_remarks_er);
  setlogin_number_er(response.data.login_number_er);
 
  seterror_msg("Cannot Update Loan Login !");  return; }

   

   //Transaction Entered Successfully
   if(response.data.successvar==1){   document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Update Lead !!"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("EditId00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* CREATE SALES FUNCTION END ********************//






return(
    <>


    <html lang="en">
      <head>
        {/*} Required meta tags */}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>BUSINESS SAMADHAN | Loan CRM</title>
        {/*} plugins:css */}
        <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
        {/*} endinject */}
        {/*} Plugin css for this page */}
        <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
        <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
        {/*} End plugin css for this page */}
        {/*} inject:css */}
        {/*} endinject */}
        {/*} Layout styles */}
        <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
        {/*} End layout styles */}
        <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
      </head>
      <body>
    
    
        <div class="container-scroller">
    
        <Sidebar />
        <div class="container-fluid page-body-wrapper">
    
    
    
    
           <Navbar />
            {/*} partial */}
            <div class="main-panel">
    
              {/* ADD CUSTOMER SUCCESS CARD START */}
              <div class="d-flex justify-content-center">
              <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success"> Loan Login Created Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <a href="loancrm-loanlogins"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* ADD CUSTOMER SUCCESS CARD END */}
    
               
              
    
              <div class="content-wrapper pb-0">
    
              
                 {/* CREATE TEAM FORM START */}
                        <div class="row">
                            <div class="col-12 grid-margin">
                         


                <div class="card">
               
                  <div class="card-body">
                    <h4 class="card-title">Loan Logins</h4>
                    <div class="form-sample">
                      <p class="card-description">manage loan logins from here</p>
                      <code>{error_msg}</code>
                    
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Bank Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ICICI Bank" id="bank_name" value={bank_name} onChange={updatebank_name} />
                            <code>{bank_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Branch Address</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="south mall road" id="branch_address" value={branch_address} onChange={updatebranch_address} />
                            <code>{branch_address_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Application Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="500000.00" id="application_amount" value={application_amount} onChange={updateapplication_amount}/>
                              <code>{application_amount_er}</code>
                           {/*}   <button class="btn btn-light" hidden={firsts_count>0} onClick={addfirst}>Add this as new customer ....</button>
                              <p class="text-success" style={{display:"none"}} id="cst-customer"><b>New Customer Added!</b></p> */}
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Sanction Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="400000.00" id="sanction_amount" value={sanction_amount} onChange={updatesanction_amount} />
                            <code>{sanction_amount_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date Applied</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control"  id="date_applied" value={date_applied} onChange={updatedate_applied} />
                            <code>{date_applied_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date Sanctioned</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date_result" value={date_result} onChange={updatedate_result} />
                              <small class="text-muted" style={{fontSize:"0.7rem", textAlign:"left"}}>enter (01-01-1970) if loan not sanctioned</small>
                            <code>{date_result_er}</code>
                            </div>
                          </div>
                        </div>                     
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Login Status</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Madhya Pradesh" id="login_status" style={{padding:"1rem"}} value={login_status} onChange={updatelogin_status} >
                              <option value=" ">select login status</option>
                              <option value="applied">applied</option>
                              <option value="under review">under review</option>
                              <option value="approved">approved</option>
                              <option value="rejected">rejected</option>
                              </select>
                              <code>{login_status_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Login Number</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="LGN88Y76T" id="login_number" value={login_number} onChange={updatelogin_number} />
                            <code>{login_number_er}</code>
                            </div>
                          </div>
                        </div>      
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Login Remarks</label>
                        <textarea class="form-control" rows="2"  id="login_remarks" value={login_remarks} onChange={updatelogin_remarks} ></textarea>
                        <code>{login_remarks_er}</code>
                      </div>
                          
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={createnewlogin}>Create New Login</button>
                      
                   
                    </div>
                  </div>
                </div>
                 {/* CREATE TEAM FORM END */}

                        
                        </div>
                    </div>
                 
                   
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}
//}

export default Newcrm_createloanlogin;